import dayjs from 'dayjs';
import {
  COUPON_TAG_TYPE,
  AVAILABLE_PLATFORM,
  USER_COUPON_STATUS,
} from '../shop/constants/promotion';

export const getAvailablePlatform = ({
  available_platforms,
  available_channel_ids,
}) =>
  available_platforms.map((platform) => {
    if (
      available_channel_ids.length > 0 &&
      platform === AVAILABLE_PLATFORM.retail
    ) {
      return AVAILABLE_PLATFORM.selected_retail;
    }
    return AVAILABLE_PLATFORM[platform];
  });

export const getGeneralCouponTagTypes = (coupon) => {
  return [
    ...(coupon.first_purchase_only ? [COUPON_TAG_TYPE.firstPurchaseOnly] : []),
    ...(coupon.user_max_use_count === 1
      ? [COUPON_TAG_TYPE.oneUserMaxUseCount]
      : []),
    ...(coupon.max_use_count ? [COUPON_TAG_TYPE.firstShopper] : []),
    ...(coupon.max_use_count === coupon.use_count
      ? [COUPON_TAG_TYPE.reachLimit]
      : []),
    ...(dayjs(coupon.end_at).isBefore(dayjs())
      ? [COUPON_TAG_TYPE.expired]
      : []),
    ...(coupon.user_coupon_status === USER_COUPON_STATUS.used
      ? [COUPON_TAG_TYPE.used]
      : []),
  ];
};
